var locationSettings = [];

locationSettings.push({
  placeId: 'ChIJU16tZTEWoFMRf1jZ3AvrAlE',
  hash: 'd3572498f01fc50469f36c92280a80f5ec98c0cd2daade2938ae86c8c054a928'
});

locationSettings.push({
  placeId: 'ChIJWTtJ8vOOn1MRpXNMgg8dpig',
  hash: '5b326bddc77e4709c2ed850d64b2763401b0ae18b24f5f60733f29d054ce56c7'
});

locationSettings.push({
  placeId: 'ChIJ934sJKxVdFMRDVYhptTiHAk',
  hash: '04f720c1670dd4c8c3cac37ee0930a7e257b13bc8895f77c165bdae158e249ef'
});

locationSettings.push({
  placeId: 'ChIJe4F93AMhoFMRmHlHYOpd-I8',
  hash: 'cce9b24e0ea7d54629891f81c8236a3e6af741084730bc0ac4c32bdf735c3c1f'
});

locationSettings.push({
  placeId: 'ChIJL2LiAvgfoFMRHP3xkbJ15OI',
  hash: '270303af153af3a0801d88f8a0c242c4cdb76544c3ddf2e514253fcaade18843'
});


var placesService = null;

var initLocations = async function () {
  let locations = [];
  if (!hasLocationsInStorage()) {
    for (let i = 0; i < locationSettings.length; i++) {
      const place = await fetchPlaceData(locationSettings[i]);
      locations.push(place);
    }
    saveLocationsToStorage(locations);
  } else {
    locations = loadLocationsFromStorage();
  }
  populateLocations(locations);
}

var fetchPlaceData = async function (location) {
  const url = `https://google-hours.vercel.app/api/mud/${location.placeId}?hash=${location.hash}`
  const response = await fetch(url)
  if (response.ok) {
    const data = await response.json()
    return buildLocationFromPlace(data.place)
  }
}

var saveLocationsToStorage = function (locations) {
  window.sessionStorage.setItem('locations', JSON.stringify(locations));
}

var loadLocationsFromStorage = function () {
  var locationsJson = window.sessionStorage.getItem('locations');
  return JSON.parse(locationsJson);
}

var hasLocationsInStorage = function () {
  return (window.sessionStorage.getItem('locations') !== null);
}

var buildLocationFromPlace = function (place) {
  const components = place.address_components;
  return {
    address: {
      street: findAddressPart(components, 'street_number') + ' ' + findAddressPart(components, 'route'),
      city: findAddressPart(components, 'locality'),
      region: findAddressPart(components, 'administrative_area_level_1'),
      postal: findAddressPart(components, 'postal_code')
    },
    hours: place.opening_hours.periods,
    phone: place.formatted_phone_number
  }
}

var findAddressPart = function (components, key) {
  let part = components.filter(el => el.types.includes(key));
  if (part.length === 0) return null;
  return part[0].short_name;
}

var populateLocations = function (locationData) {
  // set the current day/time
  const d = new Date();
  let today = d.getDay();
  const nowHours = `${d.getHours()}`.padStart(2, '0')
  const nowMinutes = `${d.getMinutes()}`.padStart(2, '0')
  const now = `${nowHours}${nowMinutes}`

  // set the current day row as active
  let locations = document.getElementsByClassName('location-details');
  for (let i = 0; i < locations.length; i++) {
    let dayRows = locations[i].getElementsByClassName('day-row');
    if (dayRows[today]) {
      dayRows[today].classList.add('--current');
    }
  }

  locationData.forEach((location, i) => {
    let locationIndex = i + 1;

    let openToday = openOnDay(location, today);
    let openNow = openToday && parseInt(now) >= parseInt(getOpenTime(location, today).time) && parseInt(now) < parseInt(getCloseTime(location, today).time);

    // updates 'OPEN' status on store map section
    let openTodayElements = document.querySelectorAll('.location_' + locationIndex + '_opentoday');
    openTodayElements.forEach(element => element.style.display = (openToday && openNow) ? 'initial' : 'none');

    // updates close time on store map section and footer
    let closeTimeTodayElements = document.querySelectorAll('.location_' + locationIndex + '_closetime');
    let closeTimeText = 'Closed';
    if (openToday && openNow) {
      closeTimeText = 'Closes ' + buildTimeString(getCloseTime(location, today));
    } else if (openToday && !openNow) {
      closeTimeText = 'Opens  ' + buildTimeString(getOpenTime(location, today));
    }
    closeTimeTodayElements.forEach(element => element.innerHTML = closeTimeText);

    // updates individual day open/close times on store map section and footer

    for (let day = 0; day < 7; day++) {
      let dayRowElements = document.querySelectorAll('.location_' + locationIndex + '_hours_day_' + day);
      dayRowElements.forEach(dayRowElement => {
        if (openOnDay(location, day)) {
          let openTimeElement = dayRowElement.firstChild;
          let closeTimeElement = openTimeElement.nextSibling.nextSibling;
          openTimeElement.innerHTML = buildTimeString(getOpenTime(location, day));
          closeTimeElement.innerHTML = buildTimeString(getCloseTime(location, day));
        } else {
          dayRowElement.innerHTML = 'Closed';
        }
      });
    }
   

    // updates street, city, region, postal code, and phone on store map and footer
    let streetElements = document.querySelectorAll('.location_' + locationIndex + '_street');
    streetElements.forEach(element => element.innerHTML = location.address.street);

    let cityElements = document.querySelectorAll('.location_' + locationIndex + '_city');
    cityElements.forEach(element => element.innerHTML = location.address.city);

    let regionElements = document.querySelectorAll('.location_' + locationIndex + '_region');
    regionElements.forEach(element => element.innerHTML = location.address.region);

    let postalElements = document.querySelectorAll('.location_' + locationIndex + '_postal');
    postalElements.forEach(element => element.innerHTML = location.address.postal);

    let phoneElements = document.querySelectorAll('.location_' + locationIndex + '_phone');
    phoneElements.forEach(element => {
      element.href = 'tel:' + location.phone;
      element.innerText = location.phone;
    });
  });

  // sets address and time to visible once populated
  let addressBlocks = document.querySelectorAll('.address-block');
  addressBlocks.forEach(element => element.style.visibility = 'visible');

  let timeBlocks = document.querySelectorAll('.time');
  timeBlocks.forEach(element => element.style.visibility = 'visible');
}

var getOpenTime = function (location, dayOfWeek) {
  return location.hours.filter(el => el.open.day === dayOfWeek)[0].open;
}

var getCloseTime = function (location, dayOfWeek) {
  return location.hours.filter(el => el.close.day === dayOfWeek)[0].close;
}

var openOnDay = function (location, dayOfWeek) {
  return (location.hours.filter(el => el.open.day === dayOfWeek).length > 0);
}

var buildTimeString = function (timeData) {
  const time = timeData.time.slice(0, 2) + ":" + timeData.time.slice(2);
  return convertTime(time)
}

var convertTime = function (time) {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice(1);  // Remove full string match value
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(''); // return adjusted time or original string
}

initLocations()